/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Form } from '@organisms';

import CampaignSelect from '../CampaignSelect';

const CampaignField = ({ onChange, ...props }) => (
  <Form.Item {...props}>
    <CampaignSelect onChange={onChange} />
  </Form.Item>
);

export default CampaignField;
